export default "__VITE_ASSET__CNxmcLjL__"